// Phase 1 — Topbar: mobile menu trigger + breadcrumb + (mobile) account/theme.
import { Menu } from "lucide-react";
import { useLocation } from "react-router-dom";
import { getBreadcrumb } from "./navigation";
import { AccountMenu } from "./account-menu";
import { ThemeToggle } from "./theme-toggle";
import { FestivalNotification } from "./festival-notification";
import { CustomerEventNotification } from "./customer-event-notification";
import { Badge } from "ui/badge";
import { cn } from "lib/utils";

export function Topbar({ onOpenMobileNav }: { onOpenMobileNav: () => void }) {
  const { pathname } = useLocation();
  const crumb = getBreadcrumb(pathname);

  return (
    <header className="mz sticky top-0 z-20 flex h-16 shrink-0 items-center gap-3 border-b bg-background/95 px-4 backdrop-blur supports-[backdrop-filter]:bg-background/80">
      <button
        type="button"
        onClick={onOpenMobileNav}
        aria-label="Open navigation menu"
        className="rounded-md p-1.5 text-muted-foreground outline-none transition-colors hover:bg-muted hover:text-foreground focus-visible:ring-2 focus-visible:ring-ring md:hidden"
      >
        <Menu className="h-5 w-5" />
      </button>

      {/* Breadcrumb: Group / Screen */}
      <nav aria-label="Breadcrumb" className="min-w-0 flex-1">
        <ol className="flex list-none items-center gap-1.5 text-sm">
          {crumb.group && (
            <>
              <li className="truncate text-muted-foreground">{crumb.group}</li>
              <li className="text-muted-foreground/60" aria-hidden>
                /
              </li>
            </>
          )}
          <li className={cn("truncate font-semibold text-foreground", !crumb.label && "text-muted-foreground")}>
            {crumb.label || " "}
          </li>
        </ol>
      </nav>

      {/* Customer Birthday/Wedding Anniversary notification — before Festival */}
      <CustomerEventNotification />

      {/* Festival notification */}
      <FestivalNotification />

      {/* Version badge */}
      <Badge variant="outline" className="border-purple-600 bg-purple-100 text-purple-900 dark:bg-purple-950 dark:text-purple-200">V.4.1</Badge>

      {/* Account + theme are in the sidebar footer on desktop; surfaced here on mobile. */}
      <div className="flex items-center gap-1 md:hidden">
        <ThemeToggle />
        <AccountMenu align="end" />
      </div>
    </header>
  );
}
